/**
 * SKU管理组合Hook
 * 职责: 组合各个专用hooks，提供统一接口
 * 限制: <50行
 */

import { useCallback } from 'react';
import { useSKUData } from './hooks/useSKUData';
import { useSKUActions } from './hooks/useSKUActions';
import { useSKUForm } from './hooks/useSKUForm';

export const useSKUManagement = () => {
  // 数据管理
  const { skus, brands, loading, loadSKUs, loadBrands } = useSKUData();
  
  // 表单管理
  const {
    modalVisible,
    brandMode,
    editingSKU,
    setBrandMode,
    setModalVisible,
    setEditingSKU,
    handleCreate,
    handleEdit,
  } = useSKUForm();
  
  // 创建稳定的成功回调
  const onSuccess = useCallback(() => {
    setModalVisible(false);
    setEditingSKU(null);
    loadSKUs();
  }, [setModalVisible, setEditingSKU, loadSKUs]);
  
  // CRUD操作（包括FABE生成）
  const { 
    handleDelete, 
    handleSubmit: submitAction, 
    handleGenerateFABE,
    handleConfirmFABE,
    handleCancelFABE,
    fabeModalVisible,
    fabeLoading,
    currentSellingPoint,
    currentFABEData,
  } = useSKUActions(onSuccess);
  
  // 封装提交操作（支持新建和编辑）
  const handleSubmit = useCallback(async (values: any) => {
    return await submitAction(values, editingSKU);
  }, [submitAction, editingSKU]);

  return {
    skus,
    loading,
    modalVisible,
    brands,
    brandMode,
    editingSKU,
    setBrandMode,
    setModalVisible,
    loadSKUs,
    loadBrands,
    handleCreate,
    handleEdit,
    handleDelete,
    handleSubmit,
    handleGenerateFABE,
    handleConfirmFABE,
    handleCancelFABE,
    fabeModalVisible,
    fabeLoading,
    currentSellingPoint,
    currentFABEData,
  };
};

